import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { OrderStorageService } from '../../order-storage.service';

const MERCADOPAGO_REDIRECT_PATHS = ['failure', 'success', 'pending'] as const;

export const mercadopagoRedirectGuard: CanMatchFn = (
  _route: Route,
  segments: UrlSegment[],
) => {
  const firstSegment = segments[0]?.path;

  if (
    !firstSegment ||
    !MERCADOPAGO_REDIRECT_PATHS.includes(
      firstSegment as (typeof MERCADOPAGO_REDIRECT_PATHS)[number],
    )
  ) {
    return true;
  }

  const router = inject(Router);
  const orderStorage = inject(OrderStorageService);
  const order = orderStorage.order();

  if (!order?.token) {
    return router.createUrlTree(['/']);
  }

  const search = inject(DOCUMENT).location.search;
  const searchParams = new URLSearchParams(search);
  const queryParams: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    queryParams[key] = value;
  });

  const mp_result = firstSegment === 'failure' ? 'failure' : 'success';

  return router.createUrlTree(['/', order.token], {
    queryParams: { ...queryParams, mp_result },
  });
};
